module.exports = __webpack_public_path__ + "img/comprehensive_data_analytics.fbf35470.svg";